module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0